import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConcise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconConcise"><Path fillRule="evenodd" clipRule="evenodd" d="M9.5 2.58582L12 5.08582L14.5 2.58582L15.9142 4.00003L12 7.91424L8.08579 4.00003L9.5 2.58582ZM3 9.00003H21V11H3V9.00003ZM3 13H21V15H3V13ZM12 16.0858L15.9142 20L14.5 21.4142L12 18.9142L9.5 21.4142L8.08579 20L12 16.0858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConcise;
